<template >
    <div class="successful-popup">
        <div class="successful-popup-header">
            <i class="fas fa-times" @click="hidePopup"></i>
        </div>
        <div class="successful-popup-body">
            <img class="popup-img" :src="successfulSignSrc" />
            <span> {{ message }}</span>
        </div>
    </div>
</template>
<script>
import successfulSign from '@/images/successful-sign.png'
export default {
    name: 'SuccessfulPopup',
    props: ['message'],
    data() {
        return {
            successfulSignSrc: successfulSign
        }
    },
    mounted() {
    },
    methods: {
        hidePopup: function () {
            this.$store.commit('setSuccessMessage', "");
        }
    }
}
</script>
<style >
.successful-popup {
    position: absolute;
    top: 25%;
    left: calc(50% - 175px);
    width: 350px;
    height: 225px;
    background-color: #ffff;
    font-family: var(--main-font);
    border: 1px solid #cacaca;
    z-index: 5;
    text-align: center;
    padding: 5px;
    font-size: 16px;
    font-weight: bold;
    border-radius: 6px;
    animation-name: popup-animation;
    animation-duration: .5s;
    z-index: 9;
    padding-bottom: 10px;
}

@keyframes popup-animation {
    from {
        top: -25%;
    }

    to {
        top: 25%;
    }
}

.popup-img {
    width: 100px;
    height: auto;
}

.successful-popup-header {
    color: var(--primary-color);
    display: flex;
    justify-content: flex-end;
    width: 100%;
}

.successful-popup-header i {
    padding: 10px;
    cursor: pointer;
}

.successful-popup-body {
    padding-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 40px;
    justify-content: space-between;
}
</style>